import { defineNativeMessage } from "src/lib/native-bridge/define-native-message";

export const underlyingFollowNativeMessage = defineNativeMessage({
    type: "UNDERLYING_FOLLOW",
    fields: { isin: "string", isFollowed: "boolean" },
});

export const wikifolioWatchlistNativeMessage = defineNativeMessage({
    type: "WIKIFOLIO_WATCHLIST",
    fields: { wikifolioId: "string", isOnWatchlist: "boolean" },
});
